import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateIngredientOverridesIngredientsDetailsArgs } from '../graphql/transformers'
import { UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS } from '../redux/action-types'

const useUpdateIngredientOverridesIngredientsDetailsMutation = () => {
  const dispatch = useDispatch()

  const {
    isOverridesIngredientsDetailsLoading,
    overridesIngredientsDetailsError,
  } = useSelector(store => store.ingredients.ingredient)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateIngredientOverridesIngredientsDetailsArgs(
            data,
          ),
        },
        dispatch,
        UPDATE_INGREDIENT_OVERRIDES_INGREDIENTS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isOverridesIngredientsDetailsLoading,
      error: overridesIngredientsDetailsError,
    },
  ]
}

export default useUpdateIngredientOverridesIngredientsDetailsMutation
